// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ef8U","col":"styles_col__X48Ox"};